export default {
}



// WEBPACK FOOTER //
// ./src/app/dweller/parking/index/resources/computed.js